// @ts-nocheck
import { supabase } from '@/integrations/supabase/client';

export type ReportTarget = 'user' | 'message' | 'room';
export type ReportReason = 'spam' | 'harassment' | 'hate_speech' | 'sexual_content' | 'scam' | 'other';

export async function submitReport(targetType: ReportTarget, targetId: string, reason: ReportReason, details?: string) {
  const { data: session } = await supabase.auth.getUser();
  const me = session.user?.id;
  if (!me) throw new Error('Not authenticated');
  const { error } = await supabase.from('reports').insert({
    reporter_id: me,
    target_type: targetType,
    target_id: targetId,
    reason_code: reason,
    details: details || null,
  });
  if (error) throw error;
}


